import { useParams, Link } from 'react-router-dom';
import React, {Fragment, ReactNode, useState, useEffect} from 'react';
import {StaticPageTitle} from '@common/seo/static-page-title';
import {Trans} from '@common/i18n/trans';
import {Footer} from '@common/ui/footer/footer';
import {DashboardNavbar} from '@app/dashboard/dashboard-navbar';
import {DataTablePage} from '@common/datatable/page/data-table-page';

import {CategoriesDatatableColumns} from '@app/blog/category/categories-datatable-columns';
import {DeleteSelectedItemsAction} from '@common/datatable/page/delete-selected-items-action';
import {DataTableEmptyStateMessage} from '@common/datatable/page/data-table-emty-state-message';
import builderImage from '@app/templates/website-builder.svg';
import {DialogTrigger} from '@common/ui/overlays/dialog/dialog-trigger';
import {DataTableAddItemButton} from '@common/datatable/data-table-add-item-button';
import {CreateCategoryDialog} from '@app/blog/category/create-category-dialog';
import {BlogSidebar} from '@app/blog/blog-sidebar';
export function CategoryList() {
    const { site_id } = useParams();
    const [posts, setPosts] = useState([]);
    const [pagination, setPagination] = useState({});

   

    return (
    	<Fragment>      
	      <StaticPageTitle>
	        <Trans message="Categories" />
	      </StaticPageTitle>
	      
	      <DashboardNavbar />
	      <div className="flex h-full">
        {/* Sidebar Menu */}
        <BlogSidebar />
        {/* Main Content */}
        <div className="flex-1 p-6">
          <DataTablePage
		      endpoint={`categories/${site_id}`}
		      title={<Trans message="Categories" />}
		    
		      columns={CategoriesDatatableColumns}
		      actions={<Actions />}
		      selectedActions={<DeleteSelectedItemsAction />}
		      emptyStateMessage={
		        <DataTableEmptyStateMessage
		          image={builderImage}
		          title={<Trans message="No categories have been created yet" />}
		          filteringTitle={<Trans message="No matching categories" />}
		        />
		      }
		    />	      
        </div>
      </div>
	      	  
	        <Footer className="mt-40 px-40" />
	      
	    </Fragment>
    );
}

function Actions() {
  return (
    <DialogTrigger type="modal">
      <DataTableAddItemButton>
        <Trans message="New category" />
      </DataTableAddItemButton>
      <CreateCategoryDialog />
    </DialogTrigger>
  );
}

